import script from "./KeyboardShortcut.vue?vue&type=script&setup=true&lang=js"
export * from "./KeyboardShortcut.vue?vue&type=script&setup=true&lang=js"

import "./KeyboardShortcut.vue?vue&type=style&index=0&id=32800133&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32800133"]])

export default __exports__